const MONTH_FORMATTER = new Intl.DateTimeFormat('en', {
  month: 'long',
  year: 'numeric',
})

const LONG_DATE_FORMATTER = new Intl.DateTimeFormat('en', {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  year: 'numeric',
})

const SHORT_WEEKDAY_FORMATTER = new Intl.DateTimeFormat('en', {
  weekday: 'short',
})

export function startOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth(), 1)
}

export function shiftMonth(date, amount) {
  return new Date(date.getFullYear(), date.getMonth() + amount, 1)
}

export function toDateKey(date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function monthStartKey(date) {
  return toDateKey(startOfMonth(date))
}

export function getMonthRange(date) {
  const first = startOfMonth(date)
  const last = new Date(first.getFullYear(), first.getMonth() + 1, 0)
  return {
    first: toDateKey(first),
    last: toDateKey(last),
  }
}

export function getMonthDays(date) {
  const first = startOfMonth(date)
  const daysInMonth = new Date(first.getFullYear(), first.getMonth() + 1, 0).getDate()
  const todayKey = toDateKey(new Date())

  return Array.from({ length: daysInMonth }, (_, index) => {
    const value = new Date(first.getFullYear(), first.getMonth(), index + 1)
    const dayOfWeek = value.getDay()
    const key = toDateKey(value)

    return {
      date: value,
      key,
      number: index + 1,
      weekday: SHORT_WEEKDAY_FORMATTER.format(value).slice(0, 2),
      isWeekend: dayOfWeek === 0 || dayOfWeek === 6,
      isToday: key === todayKey,
    }
  })
}

export function formatMonth(date) {
  return MONTH_FORMATTER.format(date)
}

export function formatLongDate(date) {
  return LONG_DATE_FORMATTER.format(date)
}

export function formatHours(value) {
  const number = Number(value || 0)
  if (Number.isInteger(number)) return String(number)
  return number.toFixed(2).replace(/0+$/, '').replace(/\.$/, '')
}

export function isCurrentMonth(date) {
  const now = new Date()
  return date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth()
}
